import React, { FunctionComponent } from 'react';
import styled from 'styled-components/macro';
import { History } from 'history';
import { DeviceSize } from '../../components/basic/DeviceSize';
import { theme } from '../../theme';
import Bulletins from '../../components/bulletin/Bulletins';
import YSaatioHeader from './YSaatioHeader';
import PaddedContent from '../../components/housing/PaddedContent';

const Container = styled.div`
  position: relative;
  background: ${theme().colors.m2White};

  @media print {
    background: none;
  }
`;

const Content = styled.div`
  min-height: 50vh;
  width: 100%;
  position: relative;

  @media ${DeviceSize.desktopS} {
    margin-top: 20px;
  }

  @media print {
    margin-top: 0px;
  }
`;

const YSaatioPageContainer: FunctionComponent<{ history: History }> = ({ history, children }) => {
  return (
    <Container className="pageContent">
      <Bulletins />
      <YSaatioHeader />
      <PaddedContent paddingTop="0">
        <Content>{children}</Content>
      </PaddedContent>
    </Container>
  );
};

export default YSaatioPageContainer;
